module.exports = __webpack_public_path__ + "media/activity-level/normal-bundle-of-energy-b6dd4cfe.svg";